var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-container"},[(_vm.returnUrl)?_c('a',{attrs:{"href":_vm.returnUrl}},[_c('p',{staticClass:"return-btn"},[_vm._v(_vm._s(_vm.$t('invoice.return')))])]):_vm._e(),(_vm.showCancelTime)?_c('p',{staticClass:"cancel-btn",on:{"click":function($event){return _vm.cancelJump()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }